import { render, staticRenderFns } from "./WithManage.vue?vue&type=template&id=0b087564&"
import script from "./WithManage.vue?vue&type=script&lang=js&"
export * from "./WithManage.vue?vue&type=script&lang=js&"
import style0 from "./WithManage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports